export const getters = {
  selectedItems: state => {
    return state.itemsName?.filter(item => state.items[item.id]) || [];
  },
};
